import { useQuery } from '@tanstack/react-query';

import SalaryReconciliationsApiHandler from 'app/services/salaryReconciliationsApiHandler';

import { ListPage } from 'app/types/reconciliations';
import {
  SalaryReconciliationCompaniesRequest,
  SalaryReconciliationCompany,
} from 'app/types/salaryReconciliations';

export const SALARY_RECONCILIATION_COMPANIES_QUERY_KEY = 'fetchSalaryReconciliationCompanies';

/** Lists the companies a salary accrual reconciliation run checked or failed to check, failed first. */
const useFetchSalaryReconciliationCompanies = (
  { id, companyId, status, page, size }: SalaryReconciliationCompaniesRequest,
  enabled = true
) =>
  useQuery<ListPage<SalaryReconciliationCompany>, Error>(
    [SALARY_RECONCILIATION_COMPANIES_QUERY_KEY, id, companyId, status, page, size],
    () =>
      SalaryReconciliationsApiHandler.listReconciliationCompanies({
        id,
        companyId,
        status,
        page,
        size,
      }),
    { enabled: enabled && !!id, keepPreviousData: true }
  );

export default useFetchSalaryReconciliationCompanies;
